import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import { usePage } from '@inertiajs/vue3'

export const useMainStore = defineStore('main', () => {
    const page = usePage()
    
    // Cart count - reactive to cart_data changes
    const cartCount = computed(() => {
        return page.props.cart_data?.count || 0
    })

    // User data
    const user = computed(() => page.props.auth?.user)
    
    const userName = computed(() => {
        if (!user.value) return ''
        return user.value.name || user.value.email || ''
    })

    const isLoggedIn = computed(() => !!user.value)

    // Route detection
    const isUserPage = computed(() => {
        const url = page.url
        return url.includes('/moj-racun/')
    })

    const isDashboardActive = computed(() => {
        return page.url.includes('/moj-racun/dashboard')
    })

    const isProfileActive = computed(() => {
        return page.url.includes('/moj-racun/profil')
    })

    const isOrdersActive = computed(() => {
        return page.url.includes('/moj-racun/narocila')
    })

    // Mobile sidebar state
    const sidebarOpen = ref(false)

    const toggleSidebar = () => {
        sidebarOpen.value = !sidebarOpen.value
    }

    const closeSidebar = () => {
        sidebarOpen.value = false
    }

    return {
        page,
        cartCount,
        user,
        userName,
        isLoggedIn,
        isUserPage,
        isDashboardActive,
        isProfileActive,
        isOrdersActive,
        sidebarOpen,
        toggleSidebar,
        closeSidebar,
    }
})
